import { Component } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { ILoggedInUser } from '../../interfaces/common/loggedInUser';
import { SearchParameters } from '../../shared/models/searchParameters.model';
import { PagedResult } from '../../shared/models/pagedResult.model';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { LoggedInUserService } from '../../services/common/logged-in-user.service';
import { ReportService } from '../../services/report/report.service';
import * as XLSX from 'xlsx';
import { SearchSalaryAccountPaymentModel } from '../models/search-salary-account-payment.model';
import { CommonModule } from '@angular/common';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-salary-account-payment',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, MatProgressSpinnerModule, MatPaginatorModule, MatTableModule],
  templateUrl: './salary-account-payment.component.html',
  styleUrl: './salary-account-payment.component.scss'
})
export class SalaryAccountPaymentComponent {
  searchForm: FormGroup;
  user: ILoggedInUser;
  isUserAuthorized: boolean;
  isLoading: boolean;
  isLoadingExcel: boolean = false;
  totalCount: number;
  pageSize: number = 10;
  pageIndex: number;
  searchDone: boolean = false;
  displayedColumns: string[] = ['number', 'requestNumner', 'employee', 'lineType', 'description', 'account', 'amount', 'dateProcessed'];
  searchRequestParams: SearchParameters<SearchSalaryAccountPaymentModel>;
  pagedData: PagedResult<SearchSalaryAccountPaymentModel[]>;
  dataSource: MatTableDataSource<SearchSalaryAccountPaymentModel>;

  constructor(
    private userService: LoggedInUserService,
    private fb: FormBuilder,
    private reportService: ReportService ) 
  {}

  ngOnInit(): void {
    this.searchForm = this.fb.group({
      dateFrom: new FormControl(''),
      dateTo: new FormControl('')     
    });
      
    this.userService.currentUser$.subscribe(data => {
      this.user = data;
      if(this.user !== null && this.user.reportRight){
        this.isUserAuthorized = this.user.userRole === 'BA';       
      }      
    });
  }

  getFormValues():SearchParameters<SearchSalaryAccountPaymentModel>{
      var searchParams = new SearchParameters<SearchSalaryAccountPaymentModel>();
      searchParams.pageIndex = this.pageIndex;
      searchParams.pageSize = this.pageSize;
      searchParams.query = {
        dateFrom: this.searchForm.get('dateFrom').value || null,
        dateTo: this.searchForm.get('dateTo').value || null        
      };
      return searchParams;  
    }

  submitForm() {    
    if(this.isUserAuthorized){
      this.isLoading = true;
      this.reportService.searchSalaryAccountPayments(this.getFormValues())
        .subscribe(data => {
          this.pagedData = data;
          this.pageSize = this.pagedData.pageSize;
          this.totalCount = this.pagedData.totalCount;      
          this.dataSource = new MatTableDataSource<SearchSalaryAccountPaymentModel>(this.pagedData.items);
          this.isLoading = false;
          this.searchDone = true;
      });
    }
    else{
      this.dataSource = new MatTableDataSource<SearchSalaryAccountPaymentModel>([]);
    }
  }

  exportAllToExcel(){
    if(this.isUserAuthorized){
      var searchParams = this.getFormValues();
      searchParams.pageSize = this.totalCount;
      this.isLoadingExcel = true;
      this.reportService.searchSalaryAccountPayments(searchParams).subscribe(data => {
        this.exportToExcel(data.items);
        this.isLoadingExcel = false;
      });
    }    
  }

  exportToExcel(data : SearchSalaryAccountPaymentModel[]){
    if(this.isUserAuthorized){
      this.isLoadingExcel = true;
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);
      XLSX.utils.book_append_sheet(wb, ws, 'salary-account-payment');
      XLSX.writeFile(wb, 'Salary-account-payment.xlsx');
      this.isLoadingExcel = false;
    }      
  }
}
